import React from 'react';
import { Grid } from '@mui/material';

interface StepCardProps {
  children: React.ReactChild[] | React.ReactChild;
  testId?: string;
}

const StepCard: React.FC<StepCardProps> = ({ children, testId }: StepCardProps) => {
  return (
    <Grid
      container
      direction="column"
      sx={{
        width: { xs: '100vw', sm: '408px' },
        display: 'flex',
        alignItems: 'center',
        '& h1': {
          paddingBottom: 2,
        },
        '& .MuiFormControl-root': {
          // remove input field padding
          padding: 0,
        },
        overflowWrap: { xs: 'anywhere', sm: null },
        px: { xs: 3, sm: 0 },
        py: { xs: 0, sm: 0 },
      }}
      data-testid={testId}>
      {children}
    </Grid>
  );
};
export default StepCard;
